module.exports = __webpack_public_path__ + "img/samsung-internet-logo.337496ff.svg";